import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";

const NeedHelp = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // New state for loading

  useEffect(() => {
    const fetchData = async () => {
      // Get the token from localStorage
      const token = localStorage.getItem("token");

      if (!token) {
        setError("No token found, please login again.");
        return;
      }

      setIsLoading(true); // Start loading

      try {
        const config = {
          headers: {
            Authorization: token, // Authorization header
            "Content-Type": "application/json",
          },
        };

        const requestBody = {
          type: "contact_us", // API request body
        };

        // Send POST request to the API
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/documents/get`,

          requestBody,
          config
        );
 

        // Check if the response contains an error
        if (response.data.error) {
          setError(response.data.message);
          toast.error(response.data.message);
        } else {
          setData(response.data); // Save the response data
          // toast.success("Data fetched successfully!");
        }
      } catch (err) {
        setError("No Data: " + err.response?.data?.message || err.message);
        toast.error("Error: " + err.response?.data?.message || err.message);
      } finally {
        setIsLoading(false); // End loading
      }
    };

    fetchData(); // Call the fetch function on component mount
  }, []);

  return (
    <div>
      <div>
        {error && <p style={{ color: "red" }}>{error}</p>}
        {data ? (
          <div>
            {/* <h2>Data Retrieved:</h2> */}
            <iframe
              title="Contact Us Content"
              srcDoc={data.content} // Dynamically render the content inside the iframe
              style={{ width: "100%", height: "400px", border: "none" }}
            />
            {/* <p>Message: {data.message}</p> */}
          </div>
        ) : (
          !error &&
          isLoading && ( // Show loader only when loading and no error
            <div className="text-center">
              <Spinner animation="border" role="status">
                <span className="sr-only"></span>
              </Spinner>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default NeedHelp;
